// User reducer types
export const HANDLE_DRAWER_TOGGLE = 'HANDLE_DRAWER_TOGGLE';
export const SET_HEADER_TEXT = 'SET_HEADER_TEXT';
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';
export const LOADING_DATA = 'LOADING_DATA';
export const DATA_LOADED = 'DATA_LOADED';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const STOP_LOADING = 'STOP_LOADING';
export const SET_TAB_INDEX = 'SET_TAB_INDEX';